import Layout from '@components/Layout/Layout';
import { Button } from '@components/UI';
import { trpc } from '@/api/trpc';
import { useTrpcMutation } from '@/api/useTrpcMutation';

const RequestReport = () => {
    const reportMutation = useTrpcMutation(trpc.user.requestReport.mutationOptions(), {
        successMessage:
            'Report started. The scan usually takes over an hour; the report will be emailed to your account email address when it finishes.',
        fallbackErrorMessage: 'Failed to start report'
    });

    const handleRequestReport = () => {
        reportMutation.mutate({ type: 'highArorcPutOption' });
    };

    return (
        <Layout>
            <div className="container mx-auto px-4 my-4">
                <h1>Request Report</h1>
                <p className="text-white mb-4">Reports run in the background and are emailed to your account email address.</p>

                <div className="bg-zinc-800 border border-zinc-600 rounded mb-4">
                    <div className="px-4 py-3 border-b border-zinc-600">
                        <h5 className="mb-0">High ARORC Puts Report</h5>
                    </div>
                    <div className="px-4 py-4">
                        <p>
                            Scans optionable stocks for puts with a high Annualized Return on Risk Capital (ARORC) and a high probability of
                            expiring out of the money. The scan checks each stock in turn and usually takes over an hour; the top puts and a
                            CSV of every match are emailed to you when it finishes. Only one report runs at a time, so if another report is
                            already running, try again after it finishes. If the scan fails or is interrupted, you will get an email saying
                            so.
                        </p>
                        <Button
                            disabled={reportMutation.isPending}
                            isLoading={reportMutation.isPending}
                            variant="primary"
                            onClick={handleRequestReport}
                        >
                            Request High ARORC Puts Report
                        </Button>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default RequestReport;
